import { render } from "./AddCampusAdminModal.vue?vue&type=template&id=4c22df46&scoped=true"
import script from "./AddCampusAdminModal.vue?vue&type=script&lang=js"
export * from "./AddCampusAdminModal.vue?vue&type=script&lang=js"

import "./AddCampusAdminModal.vue?vue&type=style&index=0&id=4c22df46&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c22df46"]])

export default __exports__